var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"transform-origin":"top left","width":"1280px","height":"800px","position":"absolute","overflow":"hidden"},style:(_vm.style),attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }